import React, { useRef } from "react";
import styles from "./ClientServicesTab.module.css";
import i18n from "../../Services/i18n";
import { useToasts } from "../../LayoutComponents/ToastContext";
import ListCardContainer from "../ListCard/ListCardContainer";
import UpsertServiceOccurenceModal from "../Modal/UpsertServiceOccurenceModal";
import { useModal } from "../../Context/ModalContext";
import { usePrivileges } from "../../Context/PrivilegeContext";
import PrivilegeValidationService from "../../Services/privilegeValidationService";

const ClientServicesTab = ({ client, reloadDetailClient }) => {
  const { addToast } = useToasts();
  const serviceListRef = useRef({});
  const serviceModalRef = useRef(null);
  const { openModal } = useModal();
  const { privileges } = usePrivileges();

  const handleAddServiceClick = async () => {
    if (client.services.length === 0) {
      addToast(
        i18n.t("BoardServiceClient.ServiceOccurenceNoService"),
        "SERVICEOCCURENCENOSERVICE",
        "WARNING",
        true,
      );
      return;
    }
    if (
      !PrivilegeValidationService.ClientCanAddService(
        await privileges(),
        client.serviceOccurences.length,
      )
    ) {
      addToast(
        i18n.t("Privilege.ValidationError.MaxServicesByClient"),
        "PrivilegeValidationFailed",
        "ERROR",
        true,
      );
      return;
    }

    openModal({
      title: i18n.t("BoardServiceClient.ServiceOccurenceCreate"),
      form: "formServiceOccurence",
      wideMode: true,
      hideSaveButton: false,
      hideSaveAndCloseButton: false,
      generateReportDisabled: false,
      generateReportLabel: i18n.t("Modal.GenerateReport.ServiceReport"),
      canClose: async () => {
        const isDirty = serviceModalRef.current?.isDirty?.();
        if (!isDirty) return true;

        return window.confirm(i18n.t("Modal.UnsavedChangesConfirm"));
      },
      onSave: async () => {
        const isValid = await serviceModalRef.current.validate();
        if (!isValid) return;
        return await serviceModalRef.current.save();
      },
      onClose: () => {},
      content: (
        <UpsertServiceOccurenceModal
          ref={serviceModalRef}
          serviceOccurenceExternalId={null}
          client={client}
          horse={{ externalId: -1 }}
          onSave={() => reloadDetailClient(client, true)}
          onClose={() => {}}
        />
      ),
    });
  };

  return (
    <div className={styles.container}>
      <div className={styles.services}>
        <ListCardContainer
          hideHeader={true}
          addButtonAction={handleAddServiceClick}
          isLoading={false}
          hideEmptyHorseCard={true}
          refresh={() => reloadDetailClient(client, true)}
          dataItems={client?.serviceOccurences ?? []}
          onSelect={() => {}}
          selectedItemExternalId={client.externalId}
          type="serviceoccurence"
          ref={serviceListRef}
          storageId={"ClientServiceTab.Service"}
        />
      </div>
    </div>
  );
};

export default ClientServicesTab;
